import React from 'react';
import { EntitySwitch } from '@backstage/plugin-catalog';
import { Entity } from '@backstage/catalog-model';
import { OrganizationPage } from './OrganizationPage';
import { AdGroupPage } from './AdGroupPage';
import { TeamPage } from './TeamPage';
import { DepartmentPage } from './DepartmentPage';

export const GroupPage = () => (
  <EntitySwitch>
    <EntitySwitch.Case if={(entity: Entity) => entity?.spec?.type === 'team'}>
      <TeamPage />
    </EntitySwitch.Case>
    <EntitySwitch.Case
      if={(entity: Entity) => entity?.spec?.type === 'department'}
    >
      <DepartmentPage />
    </EntitySwitch.Case>
    <EntitySwitch.Case
      if={(entity: Entity) => entity?.spec?.type === 'ad-group'}
    >
      <AdGroupPage />
    </EntitySwitch.Case>
    <EntitySwitch.Case>
      <OrganizationPage />
    </EntitySwitch.Case>
  </EntitySwitch>
);
